import { Form } from 'formik';
import { SectionContainerContent } from '../components';
import { useSectionStyles } from './styles';
import { CheckboxWithLabel } from '@uplift/ui-v2';
import { Box } from '@mui/material';

export const IdentityVerification: React.VFC = () => {
  const { classes } = useSectionStyles();

  return (
    <SectionContainerContent>
      <Form className={classes.formGroup}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <CheckboxWithLabel
            showError
            name="identityVerified"
            label="I have confirmed the client's identity and obtained informed consent for telehealth therapy services"
            color="secondary"
          />
        </Box>
      </Form>
    </SectionContainerContent>
  );
};
